import { apiPost } from "../../utils"

export function loginAPI(data) {
    return apiPost('/api/login', data)
}
